import { criticalityMap } from '@/modules/circulabi/core';
import { useSignoffContext } from '@/modules/circulabi/hooks/useSignOff';
import { parseScore } from '@/modules/circulabi/utils/parseScore';
import debounce from '@/utils/debounce';
import {
  chakra,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
} from '@chakra-ui/react';
import React from 'react';

export function LeadTimeInput() {
  const { state, dispatch, viewOnly } = useSignoffContext();

  const onChange = React.useRef(
    debounce((val: string) => {
      dispatch({ type: 'set_leadtime', leadtime: parseScore(val) });
    }, 500),
  ).current;

  if (state.criticality?.score !== criticalityMap.medium.score) return null;

  return (
    <chakra.div display="flex">
      <FormControl>
        <FormLabel>Digite o lead time</FormLabel>
        <NumberInput
          isDisabled={viewOnly}
          min={0}
          onChange={(event) => onChange(event)}
          defaultValue={state.leadtime?.toString()}
        >
          <NumberInputField />
        </NumberInput>
      </FormControl>
    </chakra.div>
  );
}
